const router = [
    {
        path: '/nrent',
        component: () => import('../views/Nrent/Index.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/nrent/list',
        component: () => import('../views/Nrent/List.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    }
]
export default router
